package com.anjuros.website.templates.template6.modules

import com.anjuros.website.templates.template6.util.ResKey

enum class Template6ServiceInfo(
    val icon: String,
    val title: ResKey,
    val items: List<ResKey>
) {
    ServiceCard1(
        icon = "template6_services1.svg",
        title = ResKey.TEMPLATE6_SERVICE1_TITLE,
        items = listOf(
            ResKey.TEMPLATE6_SERVICE1_DESC1,
            ResKey.TEMPLATE6_SERVICE1_DESC2,
            ResKey.TEMPLATE6_SERVICE1_DESC3,
            ResKey.TEMPLATE6_SERVICE1_DESC4
        )
    ),

    ServiceCard2(
        icon = "template6_services2.svg",
        title = ResKey.TEMPLATE6_SERVICE2_TITLE,
        items = listOf(
            ResKey.TEMPLATE6_SERVICE2_DESC1,
            ResKey.TEMPLATE6_SERVICE2_DESC2,
            ResKey.TEMPLATE6_SERVICE2_DESC3,
            ResKey.TEMPLATE6_SERVICE2_DESC4
        )
    ),

    ServiceCard3(
        icon = "template6_services3.svg",
        title = ResKey.TEMPLATE6_SERVICE3_TITLE,
        items = listOf(
            ResKey.TEMPLATE6_SERVICE3_DESC1,
            ResKey.TEMPLATE6_SERVICE3_DESC2,
            ResKey.TEMPLATE6_SERVICE3_DESC3,
            ResKey.TEMPLATE6_SERVICE3_DESC4
        )
    )
}
